// removed by extract-text-webpack-plugin
module.exports = {"change-boxes":"finance_change-box_change-boxes","clearfix":"finance_change-box_clearfix","change-box":"finance_change-box_x","label":"finance_change-box_label","sub":"finance_change-box_sub","indicator":"finance_change-box_indicator","positive":"finance_change-box_positive","negative":"finance_change-box_negative"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/finance-components/src/components/change-box/style.less
// module id = 1070
// module chunks = 0